import React, { useState } from "react";
import api from "../../services/api";
import {
  Button,
  Form,
  FormGroup,
  FormControl,
  FormLabel,
} from "react-bootstrap";
import "./Login.css";
import history from "../history";
import Cookies from "universal-cookie";
import logoHolerite from "./Holerite.png";

export default function Login() {
  const cookies = new Cookies();
  const [CPF, setCPF] = useState("");
  const [password, setPassword] = useState("");

  let vCPF = "";
  let vSenha = "";
  let vValidado = 0;

  function validateForm() {
    return CPF.length > 0 && password.length > 0;
  }

  function validaSenha() {
    console.log(vSenha[0], password.toUpperCase(), vValidado[0]);
    if (vValidado[0] === "") {
      alert("Senha Não validada !!!");
    } else {
      if (vCPF[0] !== "" && vSenha[0] !== "") {
        if (password.toUpperCase() === vSenha[0].toUpperCase()) {
          history.push("/HOn/Home");
        } else {
          alert("Senha inválida !!!");
        }
      }
    }

  }

  function CarregaCadSenha() {
    history.push("/HOn/CadSenha");
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const resp = await api.get(`/datasnap/rest/tsm/reccpf("${CPF}")`);

    cookies.set(
      "ckCPF",
      resp.data.result[0].map((usua) => usua.CPF),
      { path: "/" }
    );
    cookies.set(
      "ckSenha",
      resp.data.result[0].map((usua) => usua.SENHA),
      { path: "/" }
    );
    cookies.set(
      "ckValidado",
      resp.data.result[0].map((usua) => usua.VALIDADO),
      { path: "/" }
    );
    // Salva codfunc (MATRICULA) e codfilial no cookie
    if (resp.data.result[0][0]) {
      cookies.set("codfunc", resp.data.result[0][0].MATRICULA, { path: "/" });
      cookies.set("codfilial", resp.data.result[0][0].CODFILIAL, { path: "/" });
    }

    vCPF = cookies.get("ckCPF");
    vSenha = cookies.get("ckSenha");
    vValidado = cookies.get("ckValidado");

    console.log(vCPF[0]);
    console.log(vSenha[0]);
    console.log(vValidado[0]);

    if (vCPF[0] === "") {
      alert("Usuario não cadastrado !!!");
    } else {
      validaSenha();
    }
  }

  function mostrarSenha() {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }

  return (
    <div>
      <div className="container">
        <div className="content">
          <div className="logo">
            <img src={logoHolerite} alt="Holerite" />
          </div>
          <Form onSubmit={handleSubmit}>
            <h2>HOn-LOGIN</h2>
            <FormGroup controlId="email">
              {/* bsSize="large"> */}
              <FormLabel>CPF nº</FormLabel>
              <FormControl
                autoFocus
                placeholder="somente os números"
                type="CPF"
                value={CPF}
                onChange={(e) => setCPF(e.target.value)}
              />
            </FormGroup>
            <FormGroup controlId="password">
              {/* // bsSize="large"> */}
              <FormLabel>Password</FormLabel>
              <FormControl
                autoFocus
                placeholder="digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                id="password"
              />
              <input className="chklogin"
                type="checkbox"
                name="login"
                id="login"
                onClick={(e) => mostrarSenha()}
              />{" "}
              Mostar Senha
            </FormGroup>
            <Button block disabled={!validateForm()} type="submit">
              Login
            </Button>
            <Button block onClick={(e) => CarregaCadSenha()}>
              Cadastrar
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
